<template>
    <div>
      <h1>Petty Cash Features</h1>
      <p>Discover the features of our Petty Cash management system.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PettyCashFeatures',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>